import { render, staticRenderFns } from "./videoVerificationStatistics.vue?vue&type=template&id=4e85ffe6"
import script from "./videoVerificationStatistics.vue?vue&type=script&lang=js"
export * from "./videoVerificationStatistics.vue?vue&type=script&lang=js"
import style0 from "./videoVerificationStatistics.vue?vue&type=style&index=0&id=4e85ffe6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports